import { useCallback, useLayoutEffect, useState } from 'react';

const KEY = 'gotham-theme';
const PALETTE_KEY = 'gotham-palette';
const PALETTES = ['contraste', 'emeraude'];

const readPreference = (key, allowed, initial) => {
  try {
    const value = localStorage.getItem(key);
    return allowed.includes(value) ? value : initial;
  } catch { return initial; }
};
const savePreference = (key, value) => {
  try { localStorage.setItem(key, value); } catch { /* Remain usable if storage is restricted. */ }
};

// Dark/Light theme for the Gotham Checkout back-office only. The `dark` class is
// applied to <html> while an admin screen is mounted and removed on unmount, so
// the white-label customer checkout is never affected.
export function useGothamTheme() {
  const [theme, setTheme] = useState(() => readPreference(KEY, ['light', 'dark'], 'light'));
  const [palette, updatePalette] = useState(() => readPreference(PALETTE_KEY, PALETTES, 'contraste'));

  useLayoutEffect(() => {
    const root = document.documentElement;
    root.classList.add('admin-ui');
    root.classList.toggle('dark', theme === 'dark');
    PALETTES.forEach((name) => root.classList.toggle(`palette-${name}`, name === palette));
    savePreference(KEY, theme);
    savePreference(PALETTE_KEY, palette);
  }, [theme, palette]);

  useLayoutEffect(() => () => document.documentElement.classList.remove('dark', 'admin-ui', ...PALETTES.map((name) => `palette-${name}`)), []);

  const toggle = useCallback(() => setTheme((t) => (t === 'dark' ? 'light' : 'dark')), []);
  const setPalette = useCallback((value) => { if (PALETTES.includes(value)) updatePalette(value); }, []);
  return { theme, toggle, setTheme, palette, setPalette };
}

export default useGothamTheme;
